import React from 'react';
import ReactDOM from 'react-dom';
import './assets/styles/reset.css';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core';
import App from './App';
import * as serviceWorker from './serviceWorker';
import theme from './theme';
import setAxiosGlobalConfiguration from './axios/config';
import { getRootElement } from './index.utils';
import AppContextProvider from './contexts/AppContext';
import FsScrollToTop from './ui-elements/routs/FsScrollToTop';

setAxiosGlobalConfiguration();

const reactRootEl = getRootElement();
ReactDOM.render(
  <BrowserRouter>
    <ThemeProvider theme={theme}>
      <AppContextProvider>
        <FsScrollToTop />
        <App />
      </AppContextProvider>
    </ThemeProvider>
  </BrowserRouter>,
  reactRootEl
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
